import { Auth } from "aws-amplify";
import { jwtDecode, JwtPayload } from "jwt-decode";
import { externalAuthStore } from "../../mf/externalAuthStore";

type JwtPayloadWithAzureType = JwtPayload & {
  at_hash?: string;
};

const IS_MF_BUILD =
  process.env.BUILD_MF === "1" || process.env.BUILD_TARGET === "esm";

export const getJwtToken = async (): Promise<string> => {
  if (IS_MF_BUILD && externalAuthStore.isExternalAuthActive()) {
    const token = externalAuthStore.getAccessToken();

    if (token) {
      return token;
    }
  }

  const session = await Auth.currentSession();

  return session.getAccessToken().getJwtToken();
};

export const getIdToken = async (): Promise<string> => {
  if (IS_MF_BUILD && externalAuthStore.isExternalAuthActive()) {
    const idToken = externalAuthStore.getIdToken();

    if (idToken) {
      return idToken;
    }

    const accessToken = externalAuthStore.getAccessToken();

    if (accessToken) {
      return accessToken;
    }
  }

  const session = await Auth.currentSession();

  return session.getIdToken().getJwtToken();
};

export async function getIdTokenData() {
  const idToken = await getIdToken();
  const decoded: JwtPayloadWithAzureType = jwtDecode(idToken);

  return decoded;
}
